module.exports = __webpack_public_path__ + "img/index_part2img1.f7e5e49e.jpg";